// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cLyG","rootNoMargin":"styles_rootNoMargin__34HNh"};